import React, { useContext } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { AnswerContext } from "../../../index";

import Item from "./Item";
import { Container } from "./styles";

function ListItens() {
  const { state, dispatch } = useContext(AnswerContext);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    let elements = [...state.itens];
    if (result.destination.index < result.source.index) {
      const recortado = elements.slice(
        result.destination.index,
        result.source.index
      );
      elements[result.destination.index] = elements[result.source.index];
      elements.splice(
        result.destination.index + 1,
        recortado.length,
        ...recortado
      );
      dispatch({ type: "REPLACE_ITENS", itens: elements });
    } else {
      const recortado = elements.slice(
        result.source.index + 1,
        result.destination.index + 1
      );
      elements[result.destination.index] = elements[result.source.index];
      elements.splice(result.source.index, recortado.length, ...recortado);
      dispatch({ type: "REPLACE_ITENS", itens: elements });
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div>
        <Droppable droppableId={"1"}>
          {(provided) => (
            <Container ref={provided.innerRef} {...provided.droppableProps}>
              {state.itens.map((item, idx) => (
                <Draggable draggableId={`draggable${idx}`} index={idx}>
                  {(provided2) => (
                    <div
                      {...provided2.draggableProps}
                      {...provided2.dragHandleProps}
                      ref={provided2.innerRef}
                      key={idx}
                    >
                      <Item index={idx} item={item} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Container>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  );
}

export default ListItens;
